import { Trip } from '../../lib/types/models/trip/trip'
import { TripInput } from '../../lib/types/models/trip/trip-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTrip(data: TripInput) {
  return restApiClient.url(constructApiUrl(API.trips.create.url, null)).post<Trip, TripInput>(data)
}
